module.exports = __webpack_public_path__ + "static/media/sy_dummies_ppt.d0078a32.jpeg";